"use client";

import { useState, useEffect } from "react";
import Link from "next/link";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("cookie_ok")) setVisible(true);
  }, []);

  function accept() {
    localStorage.setItem("cookie_ok", "1");
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div style={{
      position: "fixed", bottom: 20, left: "50%", transform: "translateX(-50%)",
      zIndex: 9999,
      background: "var(--ink)",
      color: "rgba(255,255,255,0.85)",
      borderRadius: 16,
      padding: "14px 18px",
      display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap",
      boxShadow: "0 8px 32px rgba(0,0,0,0.28)",
      maxWidth: "min(560px, calc(100vw - 32px))",
      width: "100%",
      fontSize: 13, fontWeight: 600,
      fontFamily: "var(--font-nunito), sans-serif",
    }}>
      <span style={{ flex: 1, minWidth: 180 }}>
        We use cookies and analytics to improve the product. By using this site you agree to our{" "}
        <Link href="/privacy" style={{ color: "var(--green-soft, #7bc79b)", fontWeight: 800, textDecoration: "underline" }}>
          Privacy Policy
        </Link>
        .
      </span>
      <button
        onClick={accept}
        style={{
          background: "var(--green)", color: "#fff",
          border: "none", borderRadius: 10,
          padding: "8px 20px", fontSize: 13, fontWeight: 800,
          cursor: "pointer", flexShrink: 0,
          fontFamily: "inherit",
        }}
      >
        OK
      </button>
    </div>
  );
}
